import PropTypes from "prop-types";
import CheckImg from "../../../../assets/check.svg";
import UnheckImg from "../../../../assets/uncheck.svg";
import { UserList } from "./usersList";

function CardEventCounter({ users, max, teamName, fiveSomes, matchPlay }) {
  const usersLength = users?.length;

  const calculateUsersArray = () => {
    if (fiveSomes) {
      return {
        users: 5 - usersLength,
        maxUsers: 5,
      };
    }
    if (matchPlay) {
      return {
        users: 2 - usersLength,
        maxUsers: 2,
      };
    }
    return {
      users: max - usersLength,
      maxUsers: max,
    };
  };

  return (
    users && (
      <>
        <div className="cardEvent-counter--wrapper">
          {Array.from(Array(usersLength).keys()).map((i) => (
            <img
              className="cardEvent-counter--item"
              key={i}
              src={CheckImg}
              alt="icon"
            />
          ))}
          {Array.from(Array(calculateUsersArray().users).keys()).map((i) => (
            <img
              key={i}
              className="cardEvent-counter--item"
              src={UnheckImg}
              alt="icon"
            />
          ))}
          <div className="cardEvent-counter--count">
            {usersLength}/{calculateUsersArray().maxUsers}
          </div>
        </div>
        <div style={{ marginTop: 8 }}>
          <UserList users={users} teamName={teamName} matchPlay={matchPlay} />
        </div>
      </>
    )
  );
}

CardEventCounter.propTypes = {
  users: PropTypes.arrayOf(
    PropTypes.shape({
      length: PropTypes.number,
    }),
  ),
  max: PropTypes.number,
  teamName: PropTypes.string,
  fiveSomes: PropTypes.bool,
  matchPlay: PropTypes.bool,
};

CardEventCounter.defaultProps = {
  users: null,
  max: 4,
  teamName: null,
  fiveSomes: false,
  matchPlay: false,
};

export { CardEventCounter };
